import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../../theme";

const MainContainer = styled.div`
  margin: 100px 0px 50px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 4rem;
  background:
    radial-gradient(
      50% 50% at 50% 50%,
      rgba(32, 95, 156, 0.2) 0%,
      rgba(64, 224, 208, 0) 100%
    ),
    radial-gradient(
      50% 50% at 50% 50%,
      rgba(64, 224, 208, 0.06) 0%,
      rgba(64, 224, 208, 0) 100%
    );

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
    gap: 2rem;
    padding: 2rem;
  }
`;

const LeftSection = styled(motion.div)`
  flex: 1;
  max-width: 600px;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;

const RightSection = styled(motion.div)`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

const Tag = styled.div`
  display: inline-block;
  color: ${theme.colors.primary};
  padding: 0.8rem 1rem;
  border-radius: 50px;
  font-size: 0.875rem;
  box-shadow: 0 4px 6px rgba(30, 144, 255, 0.3);
  border: 1px solid ${theme.colors.primary};
  font-family: "Inter", sans-serif;
`;

const Title = styled.h1`
  font-size: 55px;
  font-weight: bold;
  color: ${theme.colors.text.primary};
  margin-bottom: 1.5rem;
  line-height: 1.15;
  font-family: "Gilroy-Bold", sans-serif;

  span {
    background: ${theme.colors.gradient.themeGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;
const TitleChild = styled.h2`
  color: ${theme.colors.text.primary};
  font-family: "Gilroy-Bold", sans-serif;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const Description = styled.p`
  font-size: 1rem;
  font-weight: 400; /* regular */
  color: ${theme.colors.text.tertiary};
  font-family: "Inter Regular", "Inter", sans-serif;

  letter-spacing: -0.4px;
  line-height: 26px;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const EmailForm = styled(motion.form)`
  display: flex;
  gap: 1rem;
  width: 600px;
  margin-top: 2rem;
  background-color: white;
  padding: 7px;
  border-radius: 10px;
  box-shadow: 2px 2px 2px 2px rgba(30, 144, 255, 0.2);
  border: 0.2px solid ${theme.colors.border};
  @media (max-width: 768px) {
    flex-direction: column;
    width: 90%;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 0px 5px 0px 5px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
  font-family: "Inter", sans-serif;

  &:focus {
    border-color: #3182ce;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Button = styled.button`
  padding: 10px;
  background-color: ${theme.colors.primary};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Inter", sans-serif;

  &:hover {
    background-color: ${theme.colors.buttonhover};
  }
`;

const SC = {
  MainContainer,
  Container,
  LeftSection,
  RightSection,
  Image,
  Tag,
  Title,
  TitleChild,
  Description,
  EmailForm,
  Input,
  Button,
};

export default SC;
